import script from "./SectionLogos.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionLogos.vue?vue&type=script&setup=true&lang=js"

import "./SectionLogos.vue?vue&type=style&index=0&id=42c88acc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42c88acc"]])

export default __exports__